import DatetimeUtils from "../../gd/utils/datetime-utils"
// import MyWorkProto from "core/model2/my-work-properties/my-work-proto"
import {
    MY_WORK_ITEM_MENTION, MY_WORK_ITEM_REMINDER,
    MY_WORK_ITEM_REPORT
} from "./my-work-types";
import MyWorkProto from "./my-work-proto";

export default class MyWorkReminder extends MyWorkProto {

    public reminder     : any // ??? why any

    constructor(reminder:any) {
        super()

        this.reminder = reminder
    }

    schedule(date:any) {
        console.log("Schedule called")
    }

    get isPastdue() {
        return DatetimeUtils.isBeforeToday(this.startDate)
    }

    // set myWorkStartDate(value) {
    //     console.warn("*** Depricated 3399445 - set item property direct or add schedule method to reminder my work model")
    //     // this.reminder.scheduleDate = value
    // }
    //
    // set myWorkEndDate(value) {
    //     // do nothing here
    // }

    get mentionTitle() {


        let fromName = "You've been mentioned in  ";
        if (this.reminder.properties.mentionedByUserId) {
            const mentionedByUser = gd.session.users.get(this.reminder.properties.mentionedByUserId)!;
            fromName = mentionedByUser.name +" mentioned you in ";
        }

        return fromName + " " + this.reminder.title
    }

    get title() {
        return this.reminder.title
    }

    get canMoveToInbox() { return true }
    // get canMoveToSomeday() { return false }
    get canChangeDate() { return true }

    // this.fromUserId             = this.item.createdByUserId
    // this.isNew                  = _.get(data, 'isNew', null)
    // this.myWorkId               = _.get(data, 'myWorkId', null)                  // for sort position saving
    // this.myWorkEndDate          = _.get(data, 'myWorkEndDate', null)
    // this.myWorkDateCreated      = data['myWorkDateCreated'] ? DatetimeUtils.datetimeToMoment(data['myWorkDateCreated']) : null
    // this.myWorkCanMoveToInbox   = _.get(data, 'myWorkCanMoveToInbox', false)
    // this.myWorkCanMoveToSomeday = _.get(data, 'myWorkCanMoveToSomeday', false)
    // this.myWorkCanChangeDate    = _.get(data, 'myWorkCanChangeDate', false)
    //
    // this.startMoment            = null
    // this.endMoment              = null

    get myWorkId() { return this.reminder.rid }

    get myWorkType() {
        switch (this.reminder.reminderType) {
            case gd.const.reminders.type.MENTION    : return MY_WORK_ITEM_MENTION
            case gd.const.reminders.type.REPORT     : return MY_WORK_ITEM_REPORT
            case gd.const.reminders.type.GENERIC    :
            default                                 : return MY_WORK_ITEM_REMINDER
        }
    }

    get fromUserId() {
        switch (this.reminder.reminderType) {
            case gd.const.reminders.type.MENTION    : return _.get(this.reminder, 'properties.mentionedByUserId', this.reminder.createdByUserId)
            case gd.const.reminders.type.REPORT     : return null
            case gd.const.reminders.type.GENERIC    :
            default                                 : return this.reminder.createdByUserId
        }
    }

    get dateCreated() {
        let sinceMoment = _.get(this.reminder, 'properties.myWork.sinceMoment', null)

        // PAtch by vic ... stranno chto to pomenyatlos' hez
        if (!sinceMoment && this.reminder.momentCreated) {
            sinceMoment = this.reminder.momentCreated
        }

        const momentCreated =  sinceMoment ? DatetimeUtils.dateToMoment(sinceMoment) : momentDate()

        return momentCreated
    }

    get startMoment() { return null }   // when we have time
    get endMoment() { return null }     // not sure if needed

    get startDate() {
        // const myWorkStartDate = this.scheduleMoment ? this.scheduleMoment : this.scheduleDate   // ?
        return this.reminder.scheduleDate
    }

    get endDate() {
        // const myWorkStartDate = this.scheduleMoment ? this.scheduleMoment : this.scheduleDate   // ?
        return this.reminder.scheduleDate
    }

    // toJSON() {
    //     let res = {}
    //
    //     _.mapKeys(this, (value, key)=>{
    //         switch (key) {
    //             case 'myWorkDateCreated':
    //                 res[key] = value ? DatetimeUtils.momentToUTCISODatetime(value) : null
    //                 break
    //
    //             default: res[key] = value
    //         }
    //     })
    //
    //     return res
    // }
}
